import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyDashboardsConfigureRoute: InvariantJiraRoute = {
	name: 'legacy-dashboards-configure',
	path: '(/secure/|/)ConfigurePortalPages([!%]?[\\w]*).jspa',
};
